import { useEffect } from 'react';

export function useGoogleAdSense() {
  useEffect(() => {
    // Skip initialization in non-production environments
    if (import.meta.env?.MODE !== 'production') return;

    // Load AdSense script if not already done
    if (!document.querySelector(`script[src*="adsbygoogle.js"]`)) {
      const script = document.createElement('script');
      script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${import.meta.env?.VITE_ADSENSE_ID}`;
      script.async = true;
      script.crossOrigin = 'anonymous';
      document.head?.appendChild(script);
    }
  }, []);
}